import type {PaymentCategory} from '../../models'
import type {UpdatePaymentCategoryRequest} from '../../redux/reducers/paymentCategories/types'

/** API may return billingScheduleId as ObjectId string or populated schedule document. */
export function resolveBillingScheduleId(
  value: PaymentCategory['billingScheduleId'] | {_id?: string} | null | undefined
): string {
  if (!value) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'object' && '_id' in value && value._id) return String(value._id)
  return ''
}

/** Build update payload preserving category fields; set or clear billingScheduleId. */
export function buildPaymentCategoryScheduleUpdate(
  cat: PaymentCategory,
  billingScheduleId: string | null
): UpdatePaymentCategoryRequest {
  return {
    id: cat._id!,
    name: cat.name,
    description: cat.description,
    textColor: cat.textColor,
    backgroundColor: cat.backgroundColor,
    establishements: (cat.establishements ?? []).map((e) =>
      typeof e === 'string' ? e : e._id!
    ),
    belongsToUsers: cat.belongsToUsers ?? [],
    billingScheduleId: billingScheduleId === null ? null : billingScheduleId || undefined,
    classFees: (cat.classFees ?? []).map((cf) => ({
      ...(cf._id ? {_id: cf._id} : {}),
      classroom:
        typeof cf.classroom === 'object' && cf.classroom != null
          ? (cf.classroom as {_id?: string})._id!
          : String(cf.classroom),
      amount: cf.amount ?? 0,
      currency: cf.currency ?? 'TND',
      notes: cf.notes ?? '',
      academicYear: cf.academicYear ?? '',
    })),
  }
}
